// src/api/establecimientos.js
import api from "./config.js";

// Obtener todos los establecimientos
export const getEstablecimientos = async () => {
    const { data } = await api.get("/establecimiento");
    return Array.isArray(data) ? data : data.establecimientos || [];
};

// Obtener un establecimiento por ID
export const getEstablecimiento = async (id) => {
    const { data } = await api.get(`/establecimiento/${id}`);
    return data;
};

// Crear un nuevo establecimiento
export const createEstablecimiento = async (establecimiento) => {
    const { data } = await api.post("/establecimiento", establecimiento);
    return data;
};

// Actualizar establecimiento
export const updateEstablecimiento = async (id, establecimiento) => {
    const { data } = await api.put(`/establecimiento/${id}`, establecimiento);
    return data;
};

// Eliminar establecimiento
export const deleteEstablecimiento = async (id) => {
    const { data } = await api.delete(`/establecimiento/${id}`);
    return data;
};
